module.exports = __webpack_public_path__ + "img/icon-md-mood-06.4c009622.svg";